// src/app/redux/sagas/etablissementsSagas.js
import { call, put, takeLatest, all } from "redux-saga/effects";
import Swal from "sweetalert2";

import {
    FETCH_ETABLISSEMENTS_REQUEST,
    fetchEtablissementsSuccess,
    fetchEtablissementsFail,

    CREATE_ETABLISSEMENT_REQUEST,
    createEtablissementSuccess,
    createEtablissementFail,

    UPDATE_ETABLISSEMENT_REQUEST,
    updateEtablissementSuccess,
    updateEtablissementFail,

    DELETE_ETABLISSEMENT_REQUEST,
    deleteEtablissementSuccess,
    deleteEtablissementFail,

    setEtablissementsLoading,
} from "../actions/etablissementsActions";

import { API_BASE_URL, getRequest, postRequest, putRequest, deleteRequest } from "../../../api";

const getUid = () => sessionStorage.getItem("uid");
const getToken = () => sessionStorage.getItem("token");

// ===== FormData (payload + image) =====
export function buildEtablissementFormData(payload) {
    const fd = new FormData();

    const imageFile = payload?.imageFile || null;
    const clean = { ...payload };
    delete clean.imageFile;

    // backend attend: "payload" (JSON string) + "image"
    fd.append("payload", JSON.stringify(clean));
    if (imageFile) fd.append("image", imageFile);

    return fd;
}

// ===== Fetch =====
export function* fetchEtablissementsSaga() {
    const url = `${API_BASE_URL}/api/etablissements`;
    const uid = getUid();
    const token = getToken();

    yield put(setEtablissementsLoading(true));
    try {
        const resp = yield call(getRequest, { url, uid, token });
        yield put(fetchEtablissementsSuccess(resp.data));
    } catch (e) {
        yield put(fetchEtablissementsFail(e.response?.data?.message || e.message));
    } finally {
        yield put(setEtablissementsLoading(false));
    }
}

// ===== Create =====
export function* createEtablissementSaga(action) {
    const url = `${API_BASE_URL}/api/etablissements`;
    const uid = getUid();
    const token = getToken();

    yield put(setEtablissementsLoading(true));
    try {
        const fd = buildEtablissementFormData(action.payload);

        const resp = yield call(postRequest, {
            url,
            data: fd,
            uid,
            token,
            headers: { "Content-Type": "multipart/form-data" },
        });

        yield put(createEtablissementSuccess(resp.data));

        yield call([Swal, Swal.fire], {
            icon: "success",
            text: "Établissement ajouté",
            timer: 1400,
            showConfirmButton: false,
        });

        yield put({ type: FETCH_ETABLISSEMENTS_REQUEST });
    } catch (e) {
        const msg = e.response?.data?.message || "Erreur ajout établissement";
        yield put(createEtablissementFail(msg));
        yield call([Swal, Swal.fire], { icon: "error", text: msg, timer: 2200, showConfirmButton: false });
    } finally {
        yield put(setEtablissementsLoading(false));
    }
}

// ===== Update =====
export function* updateEtablissementSaga(action) {
    const { id, payload } = action.payload;
    const url = `${API_BASE_URL}/api/etablissements/${id}`;
    const uid = getUid();
    const token = getToken();

    yield put(setEtablissementsLoading(true));
    try {
        const fd = buildEtablissementFormData(payload);

        const resp = yield call(putRequest, {
            url,
            data: fd,
            uid,
            token,
            headers: { "Content-Type": "multipart/form-data" },
        });

        yield put(updateEtablissementSuccess(resp.data));

        yield call([Swal, Swal.fire], {
            icon: "success",
            text: "Établissement modifié",
            timer: 1400,
            showConfirmButton: false,
        });

        yield put({ type: FETCH_ETABLISSEMENTS_REQUEST });
    } catch (e) {
        const msg = e.response?.data?.message || "Erreur modification établissement";
        yield put(updateEtablissementFail(msg));
        yield call([Swal, Swal.fire], { icon: "error", text: msg, timer: 2200, showConfirmButton: false });
    } finally {
        yield put(setEtablissementsLoading(false));
    }
}

// ===== Delete =====
export function* deleteEtablissementSaga(action) {
    const { id } = action.payload;
    const url = `${API_BASE_URL}/api/etablissements/${id}`;
    const uid = getUid();
    const token = getToken();

    yield put(setEtablissementsLoading(true));
    try {
        yield call(deleteRequest, { url, uid, token });
        yield put(deleteEtablissementSuccess(id));

        yield call([Swal, Swal.fire], {
            icon: "success",
            text: "Établissement supprimé",
            timer: 1400,
            showConfirmButton: false,
        });
    } catch (e) {
        const msg = e.response?.data?.message || "Erreur suppression établissement";
        yield put(deleteEtablissementFail(msg));
        yield call([Swal, Swal.fire], { icon: "error", text: msg, timer: 2200, showConfirmButton: false });
    } finally {
        yield put(setEtablissementsLoading(false));
    }
}

// ===== Watcher =====
export function* etablissementsWatcher() {
    yield all([
        takeLatest(FETCH_ETABLISSEMENTS_REQUEST, fetchEtablissementsSaga),
        takeLatest(CREATE_ETABLISSEMENT_REQUEST, createEtablissementSaga),
        takeLatest(UPDATE_ETABLISSEMENT_REQUEST, updateEtablissementSaga),
        takeLatest(DELETE_ETABLISSEMENT_REQUEST, deleteEtablissementSaga),
    ]);
}
